<template>
  <div class="card" >
    <div class="card-body">
      <div class="change-product-seller">
        <h5 class="mb-0">RESELLER</h5>
         
        <p v-if="productdetail.reseller_id">
          <strong>{{ productdetail.reseller.company ? productdetail.reseller.company: ''}}</strong><br/>
          {{ productdetail.reseller.email ? productdetail.reseller.email : ''}} <br/>
          {{ productdetail.reseller.mobile ? productdetail.reseller.mobile : ''}}
        </p>

         <vue-autosuggest
            :suggestions="resellerSuggestions"
            :input-props="{class:'form-control', id:'autosuggest_reseller_input', placeholder:'Change Reseller'}"
            @input="onChangeResellerInput"
            @selected="selectResellerHandler"
            @click="onChangeResellerInput"
            :getSuggestionValue="resellerSuggestionsValue"
          >  
          <template slot-scope="{suggestion}">
            <span class="my-suggestion-item">{{ suggestion.item.company ? suggestion.item.company :  suggestion.item.email }}</span>
          </template>
        </vue-autosuggest>
        <p class="mt-2 mb-0"> <em>Cant find? <router-link :to="{ name: 'SuperadminCustomersAdd'}"  target="_blank">Add reseller</router-link></em></p>
        <button class="btn btn-primary mt-3" @click.prevent="updateReseller()">Update</button> 
      </div>
    </div>
  </div>
</template>

<script>
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';
import { VueAutosuggest } from 'vue-autosuggest';

export default {
  components: {
    VueAutosuggest
  },
  props: ['productdetail'],
  data() {
    return {

      resellerSuggestions: [
        {
          data:[]
        }
      ],

    }
  },
  methods:{


    onChangeResellerInput: _.debounce( function(name) {

      if(name == null) {
        name = document.getElementById('autosuggest_reseller_input').value;
      }
      const url = `${Env.baseUrl}/distributor/users/suggest-user?type=reseller`;
      AuthApis.postApi(url, {
        name: name
      }).then(res => {
        this.resellerSuggestions[0].data = res.data.payload;
      }).catch(err => {
        console.log(err)
      })
    }, 800),


     selectResellerHandler(obj) {
      this.productdetail.reseller_id = obj.item.id;
      this.productdetail.reseller = obj.item;
      this.resellerSuggestions[0].data = []
    },

    resellerSuggestionsValue(obj) {
       return obj.item.company ? obj.item.company : obj.item.email;
    },
    
    updateReseller() {
       const url = `${Env.baseUrl}/distributor/users/update-user/${this.productdetail.id}`;
      AuthApis.postApi(url, {
        type: 'reseller',
        user_id: this.productdetail.reseller_id,
      }).then(res => {
        this.$toasted.global.success({
          message: res.data.message,
        })
      }).catch(err => {
        console.log(err)
      })
    },

  }
}
</script>